import { render, staticRenderFns } from "./RowEvidencias.vue?vue&type=template&id=475c15f1&scoped=true"
import script from "./RowEvidencias.vue?vue&type=script&lang=js"
export * from "./RowEvidencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c15f1",
  null
  
)

export default component.exports